import React from 'react';

export interface ItemContentProps extends React.HTMLAttributes<HTMLDivElement> {}

function ItemContent({ className = '', children, ...props }: ItemContentProps): JSX.Element {
  return (
    <div className={`stepper-item-content ${className}`} aria-current="step" {...props}>
      {children}
    </div>
  );
}

export default ItemContent;
